import { useState, useCallback } from "react";
import * as api from "../api";
import { equipoPrincipal } from "../utils";

export function useAgenda(token, currentUser, showToast, teams = []) {
  const [agenda, setAgenda] = useState([]);

  const loadAgenda = useCallback(async (userId) => {
    if (!token) return;
    try {
      const data = await api.getAgenda(userId);
      if (Array.isArray(data)) {
        if (userId && String(userId) !== String(currentUser?.id)) {
          // Vista de otro usuario — reemplazar solo sus entradas
          setAgenda(prev => {
            const others = prev.filter(a => String(a.user_id) !== String(userId));
            return [...others, ...data];
          });
        } else {
          setAgenda(data);
        }
      }
    } catch (e) {
      showToast("Error al cargar agenda", "error");
    }
  }, [token]);

  const createEntry = async (d) => {
    try {
      const payload = {
        user_id:     d.user_id     || undefined,
        entry_date:  d.entry_date,
        start_date:  d.start_date  || null,
        end_date:    d.end_date    || null,
        start_time:  d.start_time  || null,
        end_time:    d.end_time    || null,
        type:        d.type        || "Tarea Principal",
        // Sin equipo indicado se asume el de quien apunta, no el de TIC.
        department:  d.department  || equipoPrincipal(currentUser, teams),
        description: d.description || "",
        recipient:   d.recipient   || "",
        priority:    d.priority    || "Media",
        status:      d.status      || "Completada",
        task_id:     d.task_id     || null,
        project_id:  d.project_id  || null,
        // Vínculo Notion — debe conservarse al crear y al duplicar entradas
        external_task_id:    d.external_task_id    || null,
        external_project_id: d.external_project_id || null,
      };
      // El desglose solo viaja si lo hay: una entrada sin subtareas deja la
      // columna a NULL en vez de guardar un array vacío en cada fila.
      if (Array.isArray(d.subtareas) && d.subtareas.length) payload.subtareas = d.subtareas;
      // Duración: minutes tiene prioridad; si no, se envía hours (el backend convierte)
      if (d.minutes !== undefined && d.minutes !== null) payload.minutes = d.minutes;
      else if (d.hours !== undefined && d.hours !== null) payload.hours = d.hours;
      else payload.minutes = 30;
      const newEntry = await api.createAgendaEntry(payload);
      setAgenda(p => [newEntry, ...p]);
      return newEntry;
    } catch (e) {
      showToast(e.message || "Error al crear entrada", "error");
    }
  };

  const updateEntry = async (id, patch) => {
    try {
      await api.updateAgendaEntry(id, patch);
      // No sobreescribir con respuesta del servidor — el estado local ya está actualizado
    } catch (e) {
      showToast(e.message || "Error al actualizar entrada", "error");
    }
  };

  const deleteEntry = async (id) => {
    try {
      await api.deleteAgendaEntry(id);
      setAgenda(p => p.filter(a => String(a.id) !== String(id)));
    } catch (e) {
      showToast(e.message || "Error al eliminar entrada", "error");
    }
  };

  return { agenda, setAgenda, loadAgenda, createEntry, updateEntry, deleteEntry };
}
